import type { CodeBlockOptions } from "@tiptap/extension-code-block"
import CodeBlock from "@tiptap/extension-code-block"

interface CodeBlockEditorOptions extends Partial<CodeBlockOptions> {}

export const CodeBlockNode = CodeBlock.extend<CodeBlockEditorOptions>({
  addAttributes() {
    return {
      ...this.parent?.(),
      filename: {
        default: null,
        parseHTML: element => {
          const filename = element.getAttribute("data-filename")
          return filename || null
        },
        renderHTML: attributes => {
          if (!attributes.filename) return {}
          return {
            "data-filename": attributes.filename,
          }
        },
      },
    }
  },

  addOptions(): CodeBlockEditorOptions {
    return {
      ...this.parent?.(),
      HTMLAttributes: {},
    }
  },
})
